import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  RootContainer,
  Form,
  Banner,
  Container,
  Title,
  FormContainer,
  FilledButton,
  BackText,
} from "../Authentication.style";
import { api } from "@api";
import { saveToken, saveUser } from "@redux/auth/authSlice";
import { openAlert } from "@redux/app/appSlice";
import { localStorage } from "@utils";
import { useDispatch } from "react-redux";
import { Alert } from "@components";
import { useTranslation } from "react-i18next";
import { InputPassword } from "@components";

const ResetPassword = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state: phone } = useLocation();
  const [loading, setLoading] = useState(false);

  const onFinish = ({ new_pin, confirm_pin }) => {
    if (!loading) {
      if (new_pin !== confirm_pin) {
        showAlert({
          message: t("auth.resetPasswordPinNotMatch"),
          isError: true,
        });
        return;
      }
      setLoading(true);
      api
        .resetPassword({
          phone,
          new_pin,
          confirm_pin,
        })
        .then(({ user }) => {
          setLoading(false);
          successCallback(user);
          showAlert({
            message: t("auth.resetPasswordSuccessMessage"),
            successCallback: () => navigate(`/${PUBLIC_ROUTE.HOME}`),
          });
        })
        .catch((errorMsg) => {
          setLoading(false);
          showAlert({
            message: errorMsg,
            isError: true,
          });
        });
    }
  };

  const successCallback = ({ token, ...user }) => {
    // save token and user to redux
    dispatch(saveToken(token));
    dispatch(saveUser(user));

    // save token and user to localstorage
    localStorage.setToken(token);
    localStorage.setUser(user);

    // set token to request obj
    api.setSessionToken(token);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const goBack = () => {
    navigate(-1);
  };

  if (!phone) {
    return <Navigate to={`/${PUBLIC_ROUTE.HOME}`} />;
  }

  return (
    <>
      <RootContainer>
        <Banner />
        <BackText onClick={goBack}>{t("common.back")}</BackText>
        <Container>
          <Title>{t("auth.resetPasswordTitle")}</Title>
          <FormContainer>
            <Form layout="vertical" requiredMark={true} onFinish={onFinish}>
              <Form.Item
                name="new_pin"
                label={t("auth.resetPasswordNewPin")}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                  {
                    pattern: /^[0-9]{6}$/,
                    message: t("auth.createPasswordValidate"),
                  },
                ]}
              >
                <InputPassword
                  autoFocus
                  placeholder={t("auth.resetPasswordPlaceholder")}
                />
              </Form.Item>
              <Form.Item
                name="confirm_pin"
                label={t("auth.resetPasswordConfirmPin")}
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                  {
                    pattern: /^[0-9]{6}$/,
                    message: t("auth.createPasswordValidate"),
                  },
                ]}
              >
                <InputPassword
                  placeholder={t("auth.resetPasswordPlaceholder")}
                />
              </Form.Item>
              <Form.Item>
                <FilledButton htmlType="submit" loading={loading}>
                  {t("common.continue")}
                </FilledButton>
              </Form.Item>
            </Form>
          </FormContainer>
        </Container>
      </RootContainer>
      <Alert />
    </>
  );
};

export default ResetPassword;
